<template>
  <div class="today-alarm">
    <resize-container :tabShow="tabShow">
      <div class="grid-content" slot="left" v-show="tabShow">
        <tab-tree :data="viewTreeData" @changeCompany="changeCompany" @tabTreeDefault="tabTreeDefault" @tabTreeClick="tabTreeClick"></tab-tree>
      </div>
      <div class="grid-rightcontent">
        <btn-show @show="Btn" content="左边树"></btn-show>
        <div class="top">
          <el-row :gutter="14">
            <el-col :span="12">
              <div class="toptitle dn-title-bg">
                <div><span>谐波总畸变率(电压)</span></div>
                <div>
                  <span>谐波电压:</span>
                  <span :class="harmonicVoltage=='合格'?'he':'ye'" style="margin:0 3px">{{harmonicVoltage}}</span>
                </div>
              </div>
              <div class="topmiddlecontent">
                <div class="middlecontent dn-content-bg">
                  <div class="titlebox" v-for="(item,index) in totalHarmonicVoltage" :key="index">
                    <div class="xbTitle" :style="{background:item.color}">{{item.name}}</div>
                    <div class="content">
                      <span class="zt">{{item.name}}相(%)</span>
                      <span class="zt">{{item.value}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="toptitle dn-title-bg">
                <div>
                  <span>谐波总畸变率(电流)</span>
                </div>
                <div>
                  <span>谐波电流:</span>
                  <span :class="harmonicCurrent=='合格'?'he':'ye'" style="margin:0 3px">{{harmonicCurrent}}</span>
                </div>

              </div>
              <div class="toprightcontent ">
                <div class="rightcontent dn-content-bg">
                  <div class="titlebox" v-for="(item,index) in totalHarmonicELe" :key="index">
                    <div class="xbTitle" :style="{background:item.color}">{{item.name}}</div>
                    <div class="content">
                      <span class="zt">{{item.name}}相(%)</span>
                      <span class="zt">{{item.value}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="middle">
          <div class="middleselect dn-content-bg">
            <div>
              <span class="zt fc">分次显示:</span>
              <el-select size="small" @change="radioselect" v-model="showOrderType" placeholder="请选择">
                <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </div>
            <div class="selectone">
              <el-select @change="radioselect($event,true)" v-if="!showselect" size="small" v-model="loadType1" placeholder="请选择">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
              <el-select @change="radioselect($event,true)" v-if="showselect" size="small" v-model="value2" placeholder="请选择">
                <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </div>
            <div class="radiostle">
              <el-radio-group v-model="harmonicType" @change="radioselect()">
                <el-radio :label="1">谐波含有率</el-radio>
                <!-- <el-radio :label="2">谐波有效值</el-radio>
                  <el-radio :label="3">谐波功率</el-radio> -->
              </el-radio-group>
            </div>
          </div>
        </div>
        <div class="bottom">
          <el-row :gutter="14" style="margin-bottom:18px;display: flex;flex: 1;">
            <el-col :span="12" class="bottom-top">
              <div class="toptitle dn-title-bg">{{topleftname}}</div>
              <div class="topLineChartLeft dn-content-bg">
                <div id="topleft" class="guanBox"></div>
              </div>
            </el-col>
            <el-col :span="12" class="bottom-top">
              <div class="toptitle dn-title-bg">{{toprightname}}</div>
              <div class="topLineChartRight dn-content-bg">
                <div id="topright" class="guanBox"></div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="14" style="display: flex;flex: 1;">
            <el-col :span="24" class="bottom-top">
              <div class="toptitle dn-title-bg">{{bottomleftname}}</div>
              <div class="bottomLineChartLeft dn-content-bg">
                <div id="bottomleft" class="guanBox"></div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </resize-container>
  </div>
</template>
<script>
import TabTree from '@/components/common/TabTree.vue'
import BtnShow from '@/components/common/BtnShow.vue'
import api from '@common/api/index.js'
import { findDataByParam } from '@/utils/index.js'
import ResizeContainer from "@/components/common/resizeContainer.vue";
import handleData from '@/utils/handleData.js'
export default {
  components: {
    TabTree,
    BtnShow,
    ResizeContainer
  },
  data () {
    return {
      harmonicType: 1,
      btnarry: [
        '电压不平衡度',
        '电流不平衡度',
        '基波电压有效值',
        '基波电流有效值'
      ],
      activecode: '',
      tabShow: true,
      viewTreeData: [],
      selectedMeasure: {
        measureId: '',
        measureName: ''
      },
      options: [
        {
          value: '1',
          label: '电压'
        },
        {
          value: '2',
          label: '电流'
        }
      ],
      loadType: '1',
      loadType1: '1',
      options1: [
        {
          value: '1',
          label: '全部'
        },
        {
          value: '2',
          label: '奇次'
        },
        {
          value: '3',
          label: '偶次'
        }
      ],
      showOrderType: '1',
      showselect: false,
      options2: [
        {
          value: '3',
          label: '有功功率'
        },
        {
          value: '4',
          label: '无功功率'
        },
        {
          value: '5',
          label: '视在功率'
        }
      ],
      value2: '3',
      jcjgPieData: null,
      topleft: null,
      topright: null,
      bottomleft: null,
      bottomright: null,
      topleftname: 'A相谐波电流含有率',
      toprightname: 'B相谐波电流含有率',
      bottomleftname: 'C相谐波电流含有率',
      bottomrightname: '中性线谐波电流含有率',
      topleftunitname: '',
      toprightunitname: '',
      bottomleftunitname: '',
      bottomrightunitname: '',
      totalHarmonicVoltage: [],//电压
      totalHarmonicELe: [],//电流
      seriesData: [],//柱状图数据
      harmonicVoltage: '',
      harmonicCurrent: '',
    }
  },
  created () {
    let vm = this
    vm.selectedTab = 'voltage'
  },
  mounted () { },
  methods: {
    changeCompany (companyId) {
      api.frontEndPageCustomParam.getMyFrontEndPageCustomParam(companyId, '/power/Harmonic', null)
        .then(res => {
          const viewTreeData = findDataByParam('viewTree', true, res.data)
          this.viewTreeData = viewTreeData
        })
    },
    Btn () {
      let vm = this
      vm.tabShow = !vm.tabShow
      vm.$nextTick(() => {
        vm.$echarts.init(document.getElementById('jcjg')).resize()
        vm.$echarts.init(document.getElementById('topleft')).resize()
        vm.$echarts.init(document.getElementById('topright')).resize()
        vm.$echarts.init(document.getElementById('bottomleft')).resize()
        vm.$echarts.init(document.getElementById('bottomright')).resize()
      })
    },
    tabTreeDefault (e) {
      let vm = this
      vm.selectedMeasure = e
      // vm.getData()
      vm.radioselect()
    },
    tabTreeClick (e) {
      let vm = this
      vm.selectedMeasure = e
      // vm.getData()
      vm.radioselect()
    },
    //获取接口数据
    getData () {
      let vm = this
      vm.$api.tmp
        .getCurrentHarmonic(
          vm.selectedMeasure.measureId,
          vm.harmonicType,
          vm.loadType,
          vm.showOrderType
        )
        .then(res => {
          if (res.success) {
            vm.totalHarmonicELe = []
            vm.totalHarmonicVoltage = []
            vm.harmonicVoltage = res.data.harmonicVoltage
            vm.harmonicCurrent = res.data.harmonicCurrent
            res.data.totalHarmonic[0].forEach((item, i) => {
              // switch (item.name){
              //     case 'av':
              //         item.name='A'
              //         item.color='#EFB64F'
              //         vm.totalHarmonicVoltage.push(item)
              //         break;
              //     case 'bv':
              //         item.name='B'
              //         item.color="#47D6AA"
              //         vm.totalHarmonicVoltage.push(item)
              //         break;
              //     case 'cv':
              //         item.name='C'
              //         item.color="#FF696A"
              //         vm.totalHarmonicVoltage.push(item)
              //             break;
              //     case 'ac':
              //         item.name='A'
              //         item.color='#EFB64F'
              //         vm.totalHarmonicELe.push(item)
              //             break;
              //     case 'bc':
              //         item.name='B'
              //         item.color="#47D6AA"
              //         vm.totalHarmonicELe.push(item)
              //             break;
              //     case 'cc':
              //         item.name='C'
              //         item.color="#FF696A"
              //         vm.totalHarmonicELe.push(item)
              //         break;
              //     default:
              //         return
              // }
              if (item.name == 'av') {
                item.name = 'A'
                item.color = '#00AAFF'
                vm.totalHarmonicVoltage.push(item)
              } else if (item.name == 'bv') {
                item.name = 'B'
                item.color = "#52CCA3"
                vm.totalHarmonicVoltage.push(item)
              } else if (item.name == 'cv') {
                item.name = 'C'
                item.color = "#CCCC00"
                vm.totalHarmonicVoltage.push(item)
              }
              else if (item.name == 'ac') {
                item.name = 'A'
                item.color = '#8673E6'
                vm.totalHarmonicELe.push(item)
              } else if (item.name == 'bc') {
                item.name = 'B'
                item.color = "#E62E4D"
                vm.totalHarmonicELe.push(item)
              } else if (item.name == 'cc') {
                item.name = 'C'
                item.color = "#0080FF"
                vm.totalHarmonicELe.push(item)
              }
            })
            let seriesData = []
            vm.seriesData = []
            for (const i in res.data.subHarmonic) {
              const element = res.data.subHarmonic[i];
              seriesData.push(element)
              vm.seriesData.push({
                xdata: [],
                series: []
              })
            }
            seriesData.forEach((item, i) => {
              item.sort((a, b) => { return a.order - b.order })//升序
              item.forEach((temp => {
                vm.seriesData[i].xdata.push(temp.order)
                vm.seriesData[i].series.push(temp.value == '' ? '-' : Number(temp.value).toFixed(2))
              }))
            })
            vm.getSelectData()
          } else {
            vm.$message.error(res.msg)
          }

        })

    },
    radioselect (type, param) {
      if (this.harmonicType == 1 || this.harmonicType == 2) {
        this.loadType = this.loadType1
        this.showselect = false
        if (this.harmonicType == 1 && this.loadType == 1) {
          this.getTile(
            'A相谐波电压含有率',
            'B相谐波电压含有率',
            'C相谐波电压含有率',
            '%'
          )
        } else if (this.harmonicType == 1 && this.loadType == 2) {
          this.getTile(
            'A相谐波电流含有率',
            'B相谐波电流含有率',
            'C相谐波电流含有率',
            '%'
          )
        } else if (this.harmonicType == 2 && this.loadType == 1) {
          this.getTile(
            'A相谐波电压有效值',
            'B相谐波电压有效值',
            'C相谐波电压有效值',
            'V'
          )
        } else if (this.harmonicType == 2 && this.loadType == 2) {
          this.getTile(
            'A相谐波电流有效值',
            'B相谐波电流有效值',
            'C相谐波电流有效值',
            'A'
          )
        }
      } else {
        this.showselect = true
        this.loadType = this.value2
        if (this.harmonicType == 3 && this.value2 == 3) {

          this.getTile(
            'A相谐波有功功率',
            'B相谐波有功功率',
            'C相谐波有功功率',
            'W'
          )
        } else if (this.harmonicType == 3 && this.value2 == 4) {
          this.getTile(
            'A相谐波无功功率',
            'B相谐波无功功率',
            'C相谐波无功功率',
            'Var'
          )
        } else if (this.harmonicType == 3 && this.value2 == 5) {
          this.getTile(
            'A相谐波视在功率',
            'B相谐波视在功率',
            'C相谐波视在功率',
            'VA'
          )
        }
      }
      this.getData()
    },
    getSelectData () {
      this.getBarEchart(
        'topleft',
        this.topleft,
        this.topleftname,
        '#00AAFF',
        this.topleftunitname,
        this.seriesData[0].xdata,
        [
          {
            data: this.seriesData[0].series,
            type: 'bar',
            name: this.topleftname
          }
        ]
      )
      this.getBarEchart(
        'topright',
        this.topright,
        this.toprightname,
        '#52CCA3',
        this.toprightunitname,
        this.seriesData[1].xdata,
        [
          {
            data: this.seriesData[1].series,
            type: 'bar',
            name: this.toprightname
          }
        ]
      )
      this.getBarEchart(
        'bottomleft',
        this.bottomleft,
        this.bottomleftname,
        '#CCCC00',
        this.bottomleftunitname,
        this.seriesData[2].xdata,
        [
          {
            data: this.seriesData[2].series,
            type: 'bar',
            name: this.bottomleftname
          }
        ]
      )
    },
    //得到图例名称
    getTile (topleftname, toprightname, bottomleftname, unit) {
      this.topleftname = topleftname
      this.toprightname = toprightname
      this.bottomleftname = bottomleftname
      this.topleftunitname = unit
      this.toprightunitname = unit
      this.bottomleftunitname = unit
    },
    getBarEchart (id, chartName, title, color, unit, xdata, series) {
      let vm = this
      if (chartName == null) {
        chartName = vm.$echarts.init(document.getElementById(id))
      } else {
        chartName.clear()
      }
      chartName = vm.$echarts.init(document.getElementById(id))
      var option = {
        legend: {
          height: '80%',
          left: 'center',
          top: '5%',
          data: [title],
          textStyle: {
            color: "#666"
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        color: [color],
        xAxis: {
          type: 'category',
          data: xdata,
          axisLine: {
            lineStyle: {
              color: "#666"
            }
          }
        },
        yAxis: {
          type: 'value',
          name: unit,
          axisLine: {
            lineStyle: {
              color: "#666"
            }
          }
        },
        series: series
      }
      chartName.setOption(option, true)
      window.addEventListener('resize', function () {
        chartName.resize()
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.today-alarm {
  padding: 14px;
  box-sizing: border-box;
  height: 100%;
  width: 100%;
}
.person {
  height: 100%;
}
.grid-content {
  position: relative;
  height: 100%;
  background: #d5dadd;
  color: rgba(24, 24, 24, 1);
  overflow: auto;
  border-radius: 4px;
}
.grid-rightcontent {
  position: relative;
  height: 100%;
  color: rgba(24, 24, 24, 1);
  display: flex;
  flex-direction: column;
}
.toptitle {
  color: #fff;
  font-weight: bold;
  display: flex;
  padding: 5px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  font-size: 16px;
  justify-content: space-between;
}
.top {
  /*flex: 1;*/
  .topleftcontent {
    background: #fff;
    border: 1px solid #eee;
    height: 12vh;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  .topmiddlecontent {
    // background: #fff;
    // margin:5px;
    height: 11vh;
  }
  .toprightcontent {
    height: 11vh;
  }
  .Toprightcontent {
    background: #f0f3f4;
    border-radius: 4px;
    width: 100%;
    white-space: normal;
    line-height: 24px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    // font-weight: bold;
    position: relative;
    height: 10.5vh;
    text-overflow: ellipsis;
    margin: 6px 0px 0px -9px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 6;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .ts {
    position: absolute;
    top: 5%;
    left: 60%;
    width: 1.5vw;
    height: 6.5vh;
    line-height: 2.6vh;
    font-size: 0.8rem;
    text-align: center;
    background: #05cfb5;
    writing-mode: vertical-lr;
    color: azure;
    border-radius: 10px;
  }
  .middlecontent {
    // background: #f0f3f4;
    display: flex;
    align-items: center;
    justify-content: center;
    // margin: 5px;
    height: 11vh;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  .rightcontent {
    // background: #f0f3f4;
    display: flex;
    align-items: center;
    justify-content: center;
    // margin: 5px;
    height: 11vh;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  .titlebox {
    display: flex;
    width: 30%;
    justify-content: space-around;
    align-items: center;
    // flex: 1;
    // flex-flow: row;
    // width: 50px;
    // height: 50px;
  }
  .content {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    font-size: 0.7rem;
    // margin: 7px 0 0 9px;
    span:nth-child(2) {
      margin-top: 10px;
      color: #111;
      font-size: 1.5rem;
      font-weight: bold;
    }
  }
}
.middle {
  /*flex: 0.1;*/
  /*flex-grow:1;*/
  margin: 14px 0;
  .middleselect {
    display: flex;
    // background: #fff;
    height: 4.5vh;
    border-radius: 4px;
    padding: 6px;
    box-sizing: border-box;
  }
}
.bottom {
  flex: 5;
  display: flex;
  flex-flow: column;
  .topLineChartLeft {
    flex: 1;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  .topLineChartRight {
    flex: 1;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  .bottomLineChartLeft {
    flex: 1;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  .bottomLineChartRight {
    flex: 1;
    background: #fff;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
}
.guanBox {
  width: 100%;
  height: 100%;
}
::v-deep .tabTree-wrap[data-v-bd1aa9c2] {
  background: #fff;
}
.hglfont {
  // width: 53px;
  // height: 26px;
  position: absolute;
  top: 90%;
  left: 41%;
  font-size: 1.5rem;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #206ee3;
  display: flex;
  justify-content: center;
}
.radiostle {
  margin: auto;
  margin-left: 0;
}
.selectone {
  margin: auto 20px;
}
.xbTitle {
  background: #04b39c;
  height: 50px;
  width: 50px;
  line-height: 50px;
  border-radius: 100%;
  color: #fff;
  font-size: 20px;
}
.bottom-top {
  box-sizing: border-box;
  display: flex;
  flex-flow: column;
  overflow: hidden;
}
.fc {
  margin-right: 8px;
}
.ye {
  color: #f86666;
}
.he {
  color: #3dc8b5;
}
</style>